import { getConfig } from '../../../../../config/environment';

/** Prefixes a CMS-relative media path with the configured media host; passes absolute URLs through. */
export function resolveMediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  const { mediaUrl } = getConfig();
  return url.startsWith('http') ? url : `${mediaUrl}${url}`;
}
